export default __webpack_public_path__ + "static/media/virtual-tour-slide-4-desktop.ff72d516.png";